module.exports = __webpack_public_path__ + "7a88139b76f3149fd27010434275a010.pdf";